import { api as axios } from '@/plugins/axios.js';

export const getSlaughterWeightProjection = async (token, batch_id = null) => {
  const config = {
    method: 'get',
    url: `/v1/slaughter-weight-projection/${batch_id}`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config).catch(() => ({ data: { results: { predictions: [] } } }));
  return data;
};
